export const PORTAL_URL = "https://portal.regaltuning.com";
// WhatsApp number UNVERIFIED — hidden until the administrator supplies a real
// number (the previous wa.me/447700900123 was an OFCOM reserved drama number,
// i.e. fake). All WhatsApp entry points are gated on this being non-null.
export const WHATSAPP_URL = null;
export const PHONE = "0333 772 1223";
export const PHONE_TEL = "tel:03337721223";
export const EMAIL = "info@regaltuning.com";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
// Canonical public origin — used for canonical tags, JSON-LD URLs, sitemap.
export const SITE_ORIGIN = "https://regaltuning.com";

export const money = (n, currency = "GBP") =>
  `${currency === "EUR" ? "€" : "£"}${Number(n).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const stockLabel = (s) =>
  s === "in_stock" ? "In stock" : s === "low" ? "Low stock" : "Out of stock";

export const CATEGORY_LABELS = {
  alientech: "Alientech",
  autotuner: "AutoTuner",
  "magic-motorsport": "Magic Motorsport",
  dimsport: "Dimsport",
  "used-equipment": "Used Equipment",
  accessories: "Accessories",
  subscriptions: "Subscriptions & Updates",
};


// JSON-LD helpers — inject/remove structured data blocks by id (captured by prerender).
export function setJsonLd(id, data) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.text = JSON.stringify(data);
}

export function removeJsonLd(id) {
  document.getElementById(id)?.remove();
}
